<template>
  <a-modal
    v-model:visible="parentState.edit.visible"
    :title="parentState.edit.title"
    width="40%"
    @ok="modalState.handleOk"
  >
    <a-form
      ref="formRef"
      :rules="modalState.rules"
      :model="parentState.edit.param"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-item label="类型组名称" name="groupName">
        <a-input
          v-model:value="parentState.edit.param.groupName"
          allow-clear
          placeholder="请输入"
          :maxlength="20"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { inject, reactive, ref } from 'vue'
import { edit_message_type_group } from 'server/modules/message'
import { message } from 'ant-design-vue'
export default {
  name: 'MessageGroupEditModal',
  setup() {
    const parentState = inject('groupState')
    const formRef = ref()
    const modalState = reactive({
      rules: {
        groupName: [
          {
            required: true,
            message: '请输入类型组名称'
          }
        ]
      },
      handleOk: async () => {
        formRef.value.validate().then(async () => {
          const { success, retInfo } = await edit_message_type_group(
            parentState.edit.param
          )

          if (success) {
            parentState.edit.visible = false
            await parentState.getList()
          } else {
            message.error(retInfo)
          }
        })
      }
    })
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      formRef,
      parentState,
      modalState
    }
  }
}
</script>

<style scoped></style>
